// 20.2.2.9 Math.cbrt(x)
var $def = require('./$.def')
  , sign = require('./$.math-sign');

$def($def.S, 'Math', {
  cbrt: function cbrt(x){
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/*****************
 ** WEBPACK FOOTER
 ** ../~/babel-polyfill/~/core-js/modules/es6.math.cbrt.js
 ** module id = 165
 ** module chunks = 0
 **/